module.exports = __webpack_public_path__ + "img/app-91aw.328047d3.png";